import { useTenant } from "hooks/settings";
import { Loaded, loadedEndpoint } from "models/loaded";
import {
  ScrapChefUsageSeries,
  useGetStrategyDashboardScrapChefUsageQuery,
} from "src/store/api/generatedApi";
import {
  GroupedScrapChefUsageSeries,
  ScrapChefUsageTimeSeries,
} from "../types";

export const useStrategyDashboardScrapChefUsage =
  (): Loaded<GroupedScrapChefUsageSeries> => {
    const loadedRawData = loadedEndpoint(
      useGetStrategyDashboardScrapChefUsageQuery({ tenantName: useTenant() })
    );
    if (loadedRawData.status === "success") {
      return {
        status: "success",
        data: buildGroupedScrapChefUsageSeries(
          loadedRawData.data.series,
          loadedRawData.data.current_usage_percentage,
          loadedRawData.data.trend_percentage,
          loadedRawData.data.development_start_date,
          loadedRawData.data.high_usage_start_date,
          loadedRawData.data.ramp_up_time
        ),
        fetching: loadedRawData.fetching,
      };
    }
    return loadedRawData;
  };

const buildGroupedScrapChefUsageSeries = (
  series: ScrapChefUsageSeries[],
  currentUsagePercentage: number,
  trendPercentage: number,
  developmentStartDate: string | null,
  highUsageStartDate: string | null,
  rampUpTime: number | null
): GroupedScrapChefUsageSeries => {
  const timeSeries: ScrapChefUsageTimeSeries = {
    date: series.map((item) => item.heat_start_date),
    rollingPercentage: series.map((item) => item.usage_percentage),
    currentUsagePercentages: series.map(
      (item) => item.current_usage_percentage
    ),
    trendPercentages: series.map((item) => item.trend_percentage),
    scrapchefRecipeEditedOutsidePercentage: series.map(
      (item) => item.scrapchef_recipe_edited_outside_percentage
    ),
  };

  return {
    values: timeSeries,
    currentUsagePercentage,
    trendPercentage,
    developmentStartDate,
    highUsageStartDate,
    rampUpTime,
  };
};
